module.exports = __webpack_public_path__ + "img/icon_dianpu_JD.557a5094.png";